import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import AppButton from './AppButton';

/**
 * Themed confirmation popup — replaces window.confirm so prompts match the app.
 * `tone`: 'brand' (default) | 'danger' picks the icon chip and the confirm button.
 */
export default function ConfirmDialog({
  open,
  title = 'Please confirm',
  message,
  detail,
  icon = '⚠',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'brand',
  onCancel,
  onConfirm,
}) {
  const danger = tone === 'danger';

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: '16px',
            border: '1px solid var(--border)',
            background: 'var(--card)',
            overflow: 'hidden',
          },
        },
      }}
    >
      <Box sx={{ p: '20px 22px 6px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
        <Box sx={{ fontFamily: 'var(--disp)', fontSize: 17, fontWeight: 700 }}>{title}</Box>
        <AppButton mini onClick={onCancel} sx={{ minWidth: 32, width: 32, height: 32, p: 0 }}>✕</AppButton>
      </Box>

      <Box sx={{ p: '8px 22px 20px', display: 'flex', gap: 1.75 }}>
        <Box
          sx={{
            width: 42,
            height: 42,
            flex: '0 0 42px',
            borderRadius: '12px',
            display: 'grid',
            placeItems: 'center',
            fontSize: 20,
            background: danger ? '#fdeaea' : '#e6f7f2',
            color: danger ? 'var(--crit)' : '#0d9488',
          }}
        >
          {icon}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Box sx={{ fontSize: 13.5, lineHeight: 1.55, color: 'var(--ink)' }}>{message}</Box>
          {detail && (
            <Box sx={{ mt: 0.75, fontSize: 12, color: 'var(--muted)' }}>{detail}</Box>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          gap: 1.25,
          justifyContent: 'flex-end',
          p: '14px 22px',
          borderTop: '1px solid var(--border)',
          background: 'var(--card-2)',
        }}
      >
        <AppButton onClick={onCancel}>{cancelLabel}</AppButton>
        <AppButton tone={danger ? 'danger' : 'primary'} onClick={onConfirm}>
          {confirmLabel}
        </AppButton>
      </Box>
    </Dialog>
  );
}
